import { appConfig } from '@/shared/config/app-config';

export type RequestUnlockEmailResult = { ok: true } | { ok: false };

export async function requestUnlockEmail(token: string): Promise<RequestUnlockEmailResult> {
    let response: Response;
    try {
        response = await fetch(`${appConfig.apiUrl}/auth/unlock/request-email`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token }),
        });
    } catch {
        return { ok: false };
    }

    // 202 is the only success; the endpoint is enumeration-safe and always returns it.
    return { ok: response.status === 202 };
}
